export default defineNuxtRouteMiddleware((to, from) => {
  const config = useRuntimeConfig();
  const publicHtmls = config.public.publicHtmls;
  if (publicHtmls.includes(to.fullPath)) {
    let redirectPath = to.fullPath;
    if (to.fullPath.startsWith("/reactNative_webViewPage/useRule")) {
      redirectPath = '/reactNative_webViewPage/useRule_20261113'
    } else if (
      to.fullPath.startsWith("/reactNative_webViewPage/personalInformation")
    ) {
      redirectPath = '/reactNative_webViewPage/personalInformation_20261113'
    }
    redirectPath += ".html";
    return navigateTo(redirectPath);
  }
});
